<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="m-0 background-primary-blue height-70px shadow z-max d-flex justify-content-center align-items-center">
        <div class="col-10 text-center color-white p-4 fs-lg">Information center</div>
        <div class="col-2 m-auto">
            <app-action-button (click)="refresh()"
                               [disabled]="!networkStatusStore.isOnline()"
                               [icon]="'m-auto fa-solid fa-rotate-right fa-xl'"
                               [loading]="loading()"></app-action-button>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="d-flex mb-3 gap-3">
            <app-big-button
                url="/main/add-animal"
                [disabled]="!userStore.canEdit()">
                <app-add-animal-svg [color]="userStore.canEdit() ? '#FEFEFE' : 'var(--bs-btn-disabled-color)'"/>
            </app-big-button>
            <app-big-button
                url="/main/add-device"
                [disabled]="!userStore.canEdit()">
                <app-add-device-svg [color]="userStore.canEdit() ? '#fff' : 'var(--bs-btn-disabled-color)'"/>
            </app-big-button>
            <app-big-button url="/main/settings">
                <i class="color-white fa-solid fa-gear fa-xl"></i>
            </app-big-button>
            @if (isNativeDevice) {
                <app-big-button url="/main/nearby-ble-tags">
                    <img height="19" src="icons/bluetooth-icon-white.svg"/>
                </app-big-button>
                <app-big-button url="/main/read-nfc-tag">
                    <img height="19" src="icons/nfc-logo-simplified-white.svg"/>
                </app-big-button>
            }
        </div>
        <div class="mb-1">
            <app-current-farm/>
        </div>
        @if (showAnimals()) {
            <div class="mb-1">
                <app-animals-button/>
            </div>
        }
        @if (showWaterSamplePoints()) {
            <div class="mb-1">
                <app-water-points-button/>
            </div>
        }
        @if (showPrecipitationSamplePoints()) {
            <div class="mb-1">
                <app-precipitation-sample-points-button/>
            </div>
        }
        @if (showProximitySamplePoints()) {
            <div class="mb-1">
                <app-proximity-sample-points-button/>
            </div>
        }
        @if (showLoRaGateways()) {
            <div class="mb-1">
                <app-gateways-button/>
            </div>
        }
        @if (showAnimals()) {
            <div class="mb-1">
                <app-grazing-patterns-button/>
            </div>
            <div class="mb-1">
                <app-signal-strength-analysis-button/>
            </div>
        }
        @if (showUnassignedTags()) {
            <div class="mb-1">
                <app-unassigned-tags-button/>
            </div>
        }
        @if (showAnimalPingSchedule()) {
            <div class="mb-1">
                <app-animal-ping-schedule-button/>
            </div>
        }
        <div class="mb-1">
            <app-paddocks-button/>
        </div>
    </div>
</div>
